import React, { ReactNode, useState } from 'react';

type TabAdapter = {
  label: string;
  view: ReactNode;
};

type Props = {
  content: TabAdapter[];
};

const Tab: React.FC<Props> = ({ content }) => {
  const [positionActive, setPositionActive] = useState(0);

  const getClickTab = (position: number) => {
    return setPositionActive(position);
  };

  const getClassNameTab = (position: number) => {
    if (positionActive === position) {
      return 'tab-item active';
    }

    return 'tab-item';
  };

  const renderTabsTitle = (tab: TabAdapter, index: number) => {
    return (
      <div
        key={tab.label}
        className={getClassNameTab(index)}
        onClick={() => getClickTab(index)}
      >
        {tab.label}
      </div>
    );
  };

  const renderTabsBody = (tab: TabAdapter, index: number) => {
    return (
      <div key={tab.label} className={getClassNameTab(index)}>
        {tab.view}
      </div>
    );
  };

  return (
    <div className="panel-body">
      <div className="panel-tab">
        <div className="panel-tab-selector">{content.map(renderTabsTitle)}</div>
        <div className="panel-tab-content">{content.map(renderTabsBody)}</div>
      </div>
    </div>
  );
};

export { Tab };
